import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController, 
AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { VerglasungPage } from './verglasung/verglasung';
 
 
@Component({ 
  selector: 'page-verglasungtype',
  templateUrl: 'verglasungtype.html',
})
export class VerglasungtypePage {
glases: any; 
glases2: any; 
selectedVerglasung: any;
selectedOrnament: any;
verglasung_cat: any; 
verglasung_img: any;
filter: false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController, public alertCtrl: AlertController ) {
  
  this.verglasung_cat = this.navParams.get('verglasung_cat');
  this.selectedVerglasung = this.navParams.get('selectedVerglasung');
  this.selectedOrnament = this.navParams.get('selectedOrnament');
  console.log(this.selectedOrnament, this.selectedVerglasung);
 
  if(this.verglasung_cat != "Ornament"){
  this.filter= true;
  }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VerglasungtypePage');
  }
 
 /*   selectVerglasung(glases, glases2){
    if(this.verglasung_cat != "Ornament"){
    this.selectedVerglasung = glases;
    this.viewCtrl.dismiss({ glases: this.selectedVerglasung });
    } else {
    this.selectedOrnament = glases;
    this.viewCtrl.dismiss({ glases2: this.selectedOrnament });
    }
}*/

   selectVerglasung(glases, glases2){
    this.selectedVerglasung = glases;
    this.viewCtrl.dismiss({ glases: this.selectedVerglasung, glases2: this.selectedOrnament });
    console.log(glases, glases2);
    }
    
    selectOrnament(glases2, glases){
    this.selectedOrnament = glases2;
    this.viewCtrl.dismiss({ glases2: this.selectedOrnament, glases: this.selectedVerglasung });
    console.log(glases2, glases);
    }


    closeModal(){
    this.viewCtrl.dismiss({ glases: this.selectedVerglasung, verglasung_img: this.verglasung_img, glases2: this.selectedOrnament });
} 

      ionViewWillEnter() : void
   {
    this.getVerglasung();
   }
   
   
  getVerglasung(){
  this.presentLoading();
  if(this.verglasung_cat == "Ornament"){
  this.userService.getVerglasung(this.verglasung_cat)
  .subscribe((data : any) =>
      { 
          this.glases2 = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        } else {
      this.userService.getVerglasung(this.verglasung_cat)
  .subscribe((data : any) =>
      { 
          this.glases = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });    
        }
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getVerglasung();
   refresher.complete();
   }
   
    showAllVerglasung() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Weitere Verglasungen');

    alert.addInput({
      type: 'radio',
      label: '3-fach Verglasung',
      value: '3-fach Verglasung',
      //checked: true
    });
     alert.addInput({
      type: 'radio',
      label: '2-fach Verglasung',
      value: '2-fach Verglasung',
    });

    alert.addButton('Cancel');
    alert.addButton({
      text: 'OK',
      handler: data => {
        //this.testRadioOpen = false;
        this.verglasung_cat = data;
        this.getVerglasung();
      }
    });
    alert.present();
  }
        

}



// WEBPACK FOOTER //
// ./src/pages/verglasungtype/verglasungtype.ts